import { IntercomArticle } from '@app/services/intercom/content';
import { useIntercom } from '@app/services/intercom/IntercomContext';
import { Icons } from '../content/icons';
import { Button, ButtonProps } from '../ui/button';

interface SupportButtonProps extends ButtonProps {
  article: IntercomArticle;
  children?: React.ReactNode | string;
}

export function SupportButton({
  article,
  children = 'Learn more',
  variant = 'support',
  ...buttonProps
}: SupportButtonProps) {
  const { showIntercomArticle } = useIntercom();
  return (
    <Button
      icon={<Icons.info />}
      variant={variant}
      onClick={() => showIntercomArticle(article)}
      className="pl-2"
      {...buttonProps}
    >
      {children}
    </Button>
  );
}
